import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Avatar from 'src/components/Avatar'
import { Text } from 'src/elements'
import { RootState } from 'src/store'
import styled from 'styled-components'

const BannerContainer = styled(Flex)`
  padding: 40px 16px 108px 16px;
  justify-content: center;
  background-image: linear-gradient(to right, #ffa830, #ff730e);
`

const ContentContainer = styled(Flex)`
  flex-direction: column;
  max-width: 940px;
  align-items: center;
`

const StyledAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  padding-top: 0;
  margin-right: 12px;
`

interface IConnectProps {
  lecture: ILecture | null
  lectureId: string | null
}
type IBannerProps = ReturnType<typeof mapState> & IConnectProps
const Banner = ({ lecture, users, lectureId }: IBannerProps) => (
  <BannerContainer>
    <ContentContainer>
      <Box flex={1} mb={20}>
        <Link to={`/lectures/${lectureId}`}>
          <Text.Topic>{lecture ? lecture.title : ''}</Text.Topic>
        </Link>
      </Box>
      <Flex>
        {lecture
          ? lecture.speakerIds.map((speakerId, idx) => (
              <Flex
                key={speakerId}
                alignItems="center"
                mr={idx === 0 ? '24px' : '0'}
              >
                <StyledAvatar userId={speakerId} fluid={true} />
                <Text.ContentWhite>
                  {users[speakerId] ? users[speakerId].fullName : null}
                </Text.ContentWhite>
              </Flex>
            ))
          : null}
      </Flex>
    </ContentContainer>
  </BannerContainer>
)

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(Banner)



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/Banner.tsx